<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card title="Add New Outbound" class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">View Transport Order</h4>
                    </div>
                    <div class="flex items-center">
                        <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="editForm" v-show="!editMode && data.transport_order.is_posted == 0">Edit</vs-button>
                        <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm" v-show="editMode" :disabled="data.transport_order_details.length > 0 ? false : true">Save</vs-button>
                    </div>
                </div>
                <vs-tabs>
                    <vs-tab label="Details">
                        <div class="vx-row mt-6">
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        TRO ID*
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.id" disabled/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Reference *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.transport_reference" :disabled="disabled_self()"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Req. Del. Date *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <flat-pickr class="w-full" v-model="data.transport_order.req_del_date" :disabled="disabled_self()"/>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Outbound Reference
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.outbound_id" :disabled="true"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Order Type *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="orderTypeOptions" v-model="data.transport_order.order_type_id" label="order_type" :clearable="false" :disabled="disabled_self()"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Client ID
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="clientOptions" v-model="data.transport_order.client_id" label="name" @input="clientChange()" :clearable="false" :disabled="disabled_self()"></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Origin *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="customerOptions" v-model="data.transport_order.origin_id" label="name" @input="setOrigin()" :clearable="false" :disabled="disabled_self()"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Address
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.origin_1" :disabled="true"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.origin_2" :disabled="true"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Origin Area *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="areaOptions" v-model="data.transport_order.origin_area_id" label="village" @search="searchArea" :clearable="false" :disabled="!editMode"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Origin Sub Area
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="areaOptions" v-model="data.transport_order.origin_subarea_id" label="village" @search="searchArea" :clearable="true" :disabled="!editMode"></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Destination *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="customerOptions" v-model="data.transport_order.destination_id" label="name" @input="setDestination()" :clearable="false" :disabled="disabled_self()"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Address
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.destination_1" :disabled="true"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.destination_2" :disabled="true"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Destination Area *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="areaOptions" v-model="data.transport_order.destination_area_id" label="village" @search="searchArea" :clearable="false" :disabled="!editMode"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Destination Sub Area
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="areaOptions" v-model="data.transport_order.destination_subarea_id" label="village" @search="searchArea" :clearable="true" :disabled="!editMode"></v-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Transport">
                        <div class="vx-row mt-6">
                            <div class="vx-col md:w-1/2 w-full">

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Transporter ID
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="transporterOption" v-model="data.transport_order.transporter_id" label="name" :reduce="transporter_id => transporter_id.id" @search="searchTransporter" :disabled="disabled_self()"></v-select>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Service Type ID
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="serviceTypeOption" v-model="data.transport_order.service_type_id" label="service_type" :reduce="service_type_id => service_type_id.id" :disabled="disabled_self()"></v-select>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Tracking Reference
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.tracking_reference" :disabled="true"/>
                                    </div>
                                </div>
                              
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                       Payment Type
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="paymentTypeOption" v-model="data.transport_order.payment_type_id" label="payment_type" :reduce="payment_type_id => payment_type_id.id" :disabled="disabled_self()"></v-select>
                                    </div>
                                </div>
                               <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Currency
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="currencyOption" v-model="data.transport_order.currency_id" label="currency_code" :reduce="currency_id => currency_id.id" :disabled="disabled_self()"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Order Value
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.order_value" :disabled="disabled_self()"/>
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Internal Notes">
                        <div class="vx-row mt-6">
                            <div class="vx-col w-full">
                                <vs-textarea v-model="data.transport_order.internal_notes" label="Internal Notes" height="200" :disabled="disabled_self()"/>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="External Notes">
                        <div class="vx-row mt-6">
                            <div class="vx-col w-full">
                                <vs-textarea v-model="data.transport_order.external_notes" label="External Notes" height="200" :disabled="disabled_self()"/>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Attachment">
                        <input 
              type="file" 
              id="file_name"
              v-on:change="handleFileUpload($event)" :hidden="!editMode"
            />
                        <vs-table :data="attachments" :hidden="editMode">
                            <template slot="thead">
                                <vs-th>No.</vs-th>
                                <vs-th>File Name</vs-th>
                                <vs-th>Action</vs-th>
                            </template>
                            <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="indextr">
                                    {{ indextr + 1 }}
                                </vs-td>
                                <vs-td :data="data[indextr].file_name">
                                    {{ data[indextr].file_name }}
                                </vs-td>
                                <vs-td :data="indextr">
                                    <vs-button color="success" class="btn mb-4 md:mb-0 mr-1" @click="removeDetail(index)" :disabled="editMode ? false : true">Download</vs-button>
                                    <vs-button color="danger" class="btn mb-4 md:mb-0 mr-1" @click="removeDetail(index)" :disabled="editMode ? false : true">Remove</vs-button>
                                </vs-td>
                            </vs-tr>
                            </template>
                        </vs-table>
                    </vs-tab>
                    <!-- <vs-tab label="Trace and Tracking">
                          <vs-table :data="data.transport_order.trace_and_tracking" stripe multiple hoverFlat>
                            <template slot="thead">
                                <vs-th>Date</vs-th>
                                <vs-th>Description</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td>
                                        <vs-input class="w-full" v-model="tr.date" />
                                    </vs-td>
                                    <vs-td>
                                        <vs-input class="w-full" v-model="tr.description" />
                                    </vs-td>
                                </vs-tr>
                            </template>
                            </vs-table>
                    </vs-tab> -->

                </vs-tabs>
            </vs-card>
            <vs-card class="p-4">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <h4>Transport Order Details</h4>
                    <vs-button @click="addItem()" class="btn mb-4 md:mb-0 mr-1" :disabled="!editMode">Add</vs-button>
                </div>
                <div style="overflow-y: auto;">
                    <table cellspacing="5">
                        <thead>
                            <tr>
                                <th style="width: 1%">Line ID</th>
                                <th style="width: 15%">Warehouse</th>
                                <th style="width: 15%">Product</th>
                                <th style="width: 10%">Description</th>
                                <th style="width: 5%">Pack ID</th>
                                <th style="width: 5%">Batch</th>
                                <th style="width: 10%">Exp. Date</th>
                                <th style="width: 5%">Qty</th>
                                <th style="width: 5%">UoM</th>
                                <th style="width: 10%">Stock Type</th>
                                <th style="width: 5%">Base Qty</th>
                                <th style="width: 5%">Base UoM</th>
                                <!-- <th>Action</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(detail, index) in data.transport_order_details" :key="index">
                                <td>
                                    <vs-input class="w-full" v-model="detail.line_id" :disabled="true"/>
                                </td>
                                <td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="detail.warehouse_id"
                                        width="100%"
                                        autocomplete
                                        :disabled="disabled_self()"
                                    >
                                        <vs-select-item v-for="(item, index) in warehouseOptions" :key="index" :value="item.value" :text="item.text"/>
                                    </vs-select>
                                </td>
                                <td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="detail.product_id"
                                        width="100%"
                                        autocomplete
                                        @change="getProduct(detail)"
                                        :disabled="disabled_self()"
                                    >
                                        <vs-select-item v-for="(item, index) in productOptions" :key="index" :value="item.value" :text="item.text"/>
                                    </vs-select>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.description" :disabled="disabled_self()"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.pack_id" :disabled="disabled_self()"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.batch" :disabled="disabled_self()"/>
                                </td>
                                <td>
                                    <flat-pickr class="w-full" v-model="detail.expired_date" :disabled="disabled_self()"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.qty" :danger="detail.qtyError" @input="convertQty(detail); validateQty(detail)" :disabled="!editMode"/>
                                </td>
                                <td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="detail.uom_id"
                                        width="100%"
                                        autocomplete
                                        @change="convertQty(detail)"
                                        @input="uomChange(detail)"
                                        :disabled="disabled_self()"
                                    >
                                        <!-- :disabled="detail.qty > 0 ? false : true" -->
                                        <vs-select-item v-for="(item, index) in detail.uomOptions" :key="index" :value="item.value" :text="item.text"/>
                                    </vs-select>
                                </td>
                                <td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="detail.stock_type_id"
                                        width="100%"
                                        autocomplete
                                        :disabled="!editMode"
                                    >
                                        <!-- :disabled="detail.product_id ? false : true" -->
                                        <vs-select-item v-for="(item, index) in stockTypeOptions" :key="index" :value="item.value" :text="item.text"/>
                                    </vs-select>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.base_qty" :disabled="true"/>
                                </td>
                                <td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="detail.base_uom_id"
                                        width="100%"
                                        autocomplete
                                        :disabled="true"
                                    >
                                        <vs-select-item v-for="(item, index) in detail.defaultUom" :key="index" :value="item.value" :text="item.text" />
                                    </vs-select>
                                </td>
                                <td>
                                    <vs-button color="danger" class="btn mb-4 md:mb-0 mr-1" @click="removeDetail(index)" :disabled="!editMode" >Remove</vs-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </vs-card>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import draggable from 'vuedraggable'

    export default {
        components:{
            vSelect,
            flatPickr,
            draggable,
        },
        data(){
            return {
                editMode: false,
                isLoading: false,
                detailsCount: 0,
                data: {
                    transport_order: {
                        id:0,
                        transport_reference: '',
                        req_del_date: '',
                        order_type_id: null,
                        origin_id: {
                            address_1: '',
                            address_2: ''
                        },
                        origin_area_id:null,
                        origin_subarea_id:null,
                        client_id: null,
                        outbound_id: null,
                        destination_id: {
                            address_1: '',
                            address_2: ''
                        },
                        destination_area_id:null,
                        destination_subarea_id:null,
                        business_type_id:null,
                        is_posted:0,
                        //transport
                        transporter_id:null,
                        service_type_id:null,
                        tracking_reference:'',
                        payment_type_id:null,
                        currency_id:null,
                        order_value:0,
                        internal_notes:'',
                        external_notes:'',
                        trace_and_tracking:[],
                    },
                    transport_order_details: [],
                },
                clientTypeOptions: [],
                areaOptions: [],
                maxRetry: 10,
                orderTypeOptions: [],
                clientOptions: [],
                customerOptions: [],

                selectedId: null,
                productOptions: [],
                warehouseOptions: [],
                stockTypeOptions: [],
                documentLock: [],
                
                  // transport
                serviceTypeOption:[],
                transporterOption:[],
                currencyOption:[],
                paymentTypeOption:[],

            }
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            disabled_self(){
                if(this.editMode == true && this.itsB2c()){
                    return true
                }
                else if(this.editMode == true && !this.itsB2c()){
                    return false
                }
                else if(this.editMode == false && this.itsB2c()){
                    return true
                }
                else if(this.editMode == false && !this.itsB2c()){
                    return true
                }
                  
            },
            itsB2c(){
                let business_type = this.data.transport_order.business_type ;
                if(business_type != null ){
                    if(business_type.code.toLowerCase() == 'b2c' ){
                        return true
                    }
                }else{
                        return false
                }
            },
            fetchData(api) {
                return this.$http.get(api)
            },
            searchArea(search, loading) {
                if(search.length > 2){
                    loading(true)
                    const data = {
                        village: search
                    }
                    this.$http.post('master/areas', data)
                    .then(res => {
                        this.areaOptions = res.data.data
                        loading(false)
                    })
                    .catch((error) => {
                        loading(false)
                        console.log(error)
                        // this.searchArea(search, loading)
                    })
                }
            },
            searchTransporter(search, loading) {
                if(search.length > 2){
                    loading(true)
                    const data = {
                        name: search
                    }
                    this.$http.post('master/transporters/filter/search', data)
                    .then(res => {
                        this.clientOption = res.data
                        loading(false)
                    })
                    .catch(() => {
                        this.searchTransporter(search, loading)
                    })
                }
            },
            handleFileUpload(event){
                this.file = event.target.files[0];
            },
            submitForm() {
                let document_send = {
                module_id:this.$route.params.id,
                module_name:'transport'
            };
                let file = new FormData();
            file.append("file_name",this.file);
            this.$http.post('/attachment/uploads',file,{
              headers: {
                  "Content-Type": "multipart/form-data"
              },
              params: document_send
            })
            .then((resp) => {
                // this.$router.replace('/inbound-delivery');
                // this.on_edit = false;
                this.isLoading = false

                this.$vs.notify({
                color: 'success',
                title: 'Update Success',
                text: 'Update Attachment Succesfully'
                });
                
               
            })
            .catch((error) =>{
                this.isLoading = false               
            });
                this.isLoading = true

                let header =  Object.assign({},this.data.transport_order) ;
                header.client_id = header.client_id != null ? header.client_id.id : null ; 
                header.origin_id = header.origin_id != null ? header.origin_id.id : null; 
                header.origin_area_id = header.origin_area_id != null ? header.origin_area_id.id : null; 
                header.origin_subarea_id = header.origin_subarea_id != null ? header.origin_subarea_id.id : null; 

                header.destination_id = header.destination_id != null ? header.destination_id.id : null; 
                header.destination_area_id = header.destination_area_id != null ? header.destination_area_id.id : null; 
                header.destination_subarea_id = header.destination_subarea_id != null ? header.destination_subarea_id.id : null; 
                
                header.order_type_id = header.order_type_id != null ? header.order_type_id.id : null; 

                const dataSend = {
                    transport_order: JSON.stringify(header),
                    transport_order_details: JSON.stringify(this.data.transport_order_details)
                }
                this.$http.put('transport/transportorder/' + this.$route.params.id + '/update', dataSend)
                .then(() => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Updated successfully',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Transport Order updated'
                    })
                    this.$router.push({ name: 'transportorder' })
                })
                .catch(error => {
                    if(error.response.data.message) {
                        error.response.data.message.map(message => {
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Error saving',
                                iconPack: 'feather',
                                icon:'icon-x',
                                text: message
                            })
                        })
                    }
                    else {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error saving',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: 'Something went wrong'
                        })
                    }
                })
                .then(() => {
                    this.isLoading = false
                })
            },
            back() {
                if(this.editMode) {
                    this.$vs.dialog({
                        color: 'warning',
                        title: 'Leave Page',
                        text: 'Changes you made may not be saved?',
                        acceptText: 'Leave Page',
                        accept: () => this.$router.go(-1),
                    })
                }
                else{
                    this.$router.go(-1)
                }
            },
            fetchAllData() {
                this.isLoading = true
                this.maxRetry = this.maxRetry - 1
                this.$http.all([
                    this.fetchData('transport/transportorder/' + this.$route.params.id),
                    ])
                .then(this.$http.spread((transport) => {
                    this.data.transport_order = transport.data.transportorder
                    
                    this.data.transport_order.client_id = transport.data.transportorder.client
                    this.data.transport_order.origin_id = transport.data.transportorder.origin
                    this.data.transport_order.origin_area_id = transport.data.transportorder.origin_area 
                    this.data.transport_order.origin_subarea_id = transport.data.transportorder.origin_subarea

                    this.data.transport_order.destination_id = transport.data.transportorder.destination
                    this.data.transport_order.destination_area_id = transport.data.transportorder.destination_area
                    this.data.transport_order.destination_subarea_id = transport.data.transportorder.destination_subarea

                    this.data.transport_order.order_type_id = transport.data.transportorder.order_type
                    
                    this.data.transport_order.outbound_id = transport.data.transportorder.outbound != null ? transport.data.transportorder.outbound.outbound_reference : null

                    this.data.transport_order_details = []
                    
                    this.transporterOption = [transport.data.transportorder.transporter] 
                    this.serviceTypeOption = [transport.data.transportorder.service_type] 
                    this.paymentTypeOption = [transport.data.transportorder.payment_type] 
                    this.currencyOption = [transport.data.transportorder.currency]

                    this.orderTypeOptions = [transport.data.transportorder.order_type]
                    this.customerOptions = [transport.data.transportorder.origin, transport.data.transportorder.destination]
                    this.areaOptions = [transport.data.transportorder.origin_area,transport.data.transportorder.origin_subarea,
                                        transport.data.transportorder.destination_area,transport.data.transportorder.destination_subarea]

                    this.productOptions = []
                    this.documentLock = transport.data.locked
                    // this.data.transport_order.trace_and_tracking =  transport.data.transportorder.trace_and_tracking

                    transport.data.transportorder_details.map(detail => {
                        detail.uomOptions = []

                        if(this.warehouseOptions.length == 0){
                            this.warehouseOptions.push({
                                value: detail.warehouse.id,
                                text: detail.warehouse.name
                            })
                        }

                        if(this.stockTypeOptions.length == 0){
                            this.stockTypeOptions.push({
                                value: detail.stock_type.id,
                                text: detail.stock_type.name
                            })
                        }

                        detail.uom_list.map(uom => {
                            detail.uomOptions.push({
                                value: uom.uom.id,
                                text: uom.uom.name,
                                numerator: uom.numerator,
                                denominator: uom.denominator
                            })
                        })

                        detail.defaultUom = [
                            {
                                value: detail.base_uom.id,
                                text: detail.base_uom.name,
                            }
                        ]
                        detail.data_status = "update"

                        this.productOptions.push({
                            value: detail.product.id,
                            text: detail.product.product_code,
                        })
                        this.data.transport_order_details.push(detail)
                        this.uomChange(detail)
                    })
                    

                    setTimeout(() => {
                        this.isLoading = false
                    }, 500)
                }))
                // .catch(() => {
                //     // if(this.maxRetry < 0){
                //     //     this.isLoading = false
                //     //     this.$vs.dialog({
                //     //         type: 'confirm',
                //     //         color: 'danger',
                //     //         title: 'Server Error',
                //     //         text: 'Try again?',
                //     //         accept: () => {
                //     //             this.fetchAllData()
                //     //             this.maxRetry = 10
                //     //         },
                //     //         cancel: () => this.$router.go(-1),
                //     //         acceptText: 'Yes',
                //     //         cancelText: 'No'
                //     //     })
                //     //     return;
                //     // }
                //     // this.fetchAllData()
                // }))
            },
            removeDetail(index){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Confirmation',
                    text: 'Delete this detail?',
                    accept: () => {
                            this.data.transport_order_details.splice(index, 1)
                    },
                    acceptText: 'Yes',
                    cancelText: 'No'
                })
            },
             addItem() {
                 console.log(this.data.transport_order.outbound)
                 if(this.data.transport_order.outbound != null){
                    let dataSend = {
                        outbound_id:this.data.transport_order.outbound.id,
                        tro_id:this.data.transport_order.id,
                        transportorder_details:JSON.stringify(this.data.transport_order_details)
                    };
                    this.$http.post('transport/transportorder/get_remaining', dataSend)
                    .then((resp) => {
                        resp.data.map((item)=>{
                            this.data.transport_order_details.push(item)
                        })
                    })
                    .catch((error) => {
                        console.log(error)
                    })
                }else{

                    if(this.productOptions.length == 0 || this.warehouseOptions.length == 0 || this.stockTypeOptions.length == 0) {
                            this.isLoading = true
                    this.productOptions = []
                    
                    this.$http.all([this.$http.post('master/warehouses'), this.$http.post('master/product/showbyclient',{ client_code: this.data.transport_order.client.client_code }), this.$http.post('master/stocktypes')])
                    .then(this.$http.spread((warehouses, products, stocktypes) => {
                            if(this.warehouseOptions.length == 0){
                                    warehouses.data.data.map(item => {
                                    this.warehouseOptions.push({
                                        value: item.id,
                                        text: item.name
                                })
                            })
                        }
    
                        if(this.productOptions.length == 0){
                                products.data.data.map(item => {
                                        this.productOptions.push({
                                        value: item.id,
                                        text: item.product_code,
                                })
                            })
                        }
    
                        if(this.stockTypeOptions.length == 0){
                                stocktypes.data.data.map(item => {
                                    this.stockTypeOptions.push({
                                    value: item.id,
                                    text: item.name,
                                })
                            })
                        }
    
                        this.detailsCount++
                        this.data.transport_order_details.push({
                            line_id: this.detailsCount,
                            warehouse_id: this.$store.state.user.userconfig.warehouse_id,
                            product_id: null,
                            description: '',
                            pack_id: '',
                            batch: '',
                            expired_date: null,
                            qty: '',
                            uom_id: null,
                            stock_type_id: this.$store.state.user.userconfig.stock_type_id,
                            committed_qty: 0,
                            base_qty: '',
                            base_uom_id: null,
                            uomOptions: [],
                            defaultUom: [],
                            qtyError: false,
                            denominator: 0,
                            numerator: 0,
                        })
    
                        setTimeout(() => {
                                this.isLoading = false
                        }, 500)
    
                        this.assignLineId()
                    }))
                    .catch(() => {
                            if(this.maxRetry < 0){
                                    this.isLoading = false
                            this.$vs.dialog({
                                    type: 'confirm',
                                color: 'danger',
                                title: 'Server Error',
                                text: 'Try again?',
                                accept: () => {
                                        this.addItem()
                                    this.maxRetry = 10
                                },
                                acceptText: 'Yes',
                                cancelText: 'No'
                            });
                            return;
                        }
                        this.addItem()
                    })
                }
                else {
                        this.detailsCount++
                    this.data.transport_order_details.push({
                            line_id: this.detailsCount,
                        warehouse_id: this.$store.state.user.userconfig.warehouse_id,
                        product_id: null,
                        description: '',
                        pack_id: '',
                        batch: '',
                        expired_date: null,
                        qty: '',
                        uom_id: null,
                        stock_type_id: this.$store.state.user.userconfig.stock_type_id,
                        committed_qty: 0,
                        base_qty: '',
                        base_uom_id: null,
                        uomOptions: [],
                        defaultUom: [],
                        qtyError: false,
                        denominator: 0,
                        numerator: 0,
                    })
                    
                    this.assignLineId()
                }
                }
            },
            getProduct(detail) {
                this.isLoading = true
                this.maxRetry--
                detail.uom_id = null
                this.fetchData('master/product/' + detail.product_id)
                .then(res => {
                    detail.uomOptions = []
                    detail.defaultUom = []

                    res.data.uoms.map(item => {
                        detail.uomOptions.push({
                            value: item.uom.id,
                            text: item.uom.name,
                            numerator: item.numerator,
                            denominator: item.denominator
                        })
                    })

                    detail.defaultUom.push({
                        value: res.data.default_uom.uom.id,
                        text: res.data.default_uom.uom.name
                    })

                    detail.description = res.data.product.description_1
                    detail.base_uom_id = res.data.default_uom.uom_id
                    detail.uom_id = res.data.default_uom.uom_id
                    this.isLoading = false
                    this.uomChange(detail)
                })
                .catch(() => {
                    if(this.maxRetry <= 0){
                        this.isLoading = false
                        this.$vs.dialog({
                            type: 'confirm',
                            color: 'danger',
                            title: 'Server Error',
                            text: 'Try again?',
                            accept: () => {
                                this.getProduct(detail)
                                this.maxRetry = 10
                            },
                            acceptText: 'Yes',
                            cancelText: 'No'
                        });
                        return;
                    }
                    this.getProduct(detail)
                })
            },
            convertQty(detail){
                detail.base_qty = (detail.qty / detail.denominator) * detail.numerator
            },
            uomChange(detail) {
                detail.uomOptions.map(uom => {
                    if(uom.value == detail.uom_id) {
                        detail.denominator = uom.denominator
                        detail.numerator = uom.numerator
                    }
                })
            },
            validateQty(detail) {
                if(detail.qty <= 0) {
                    detail.qtyError = true
                }
                else {
                    detail.qtyError = false
                }
            },
            setOrigin() {
                this.fetchData('master/customers/' + this.data.transport_order.origin_id)
                .then(res => {
                    this.data.transport_order.origin_1 = res.data.address_1
                    this.data.transport_order.origin_2 = res.data.address_2
                })
            },
            setDestination() {
                this.fetchData('master/customers/' + this.data.transport_order.destination_id)
                .then(res => {
                    this.data.transport_order.destination_1 = res.data.address_1
                    this.data.transport_order.destination_2 = res.data.address_2
                })
            },
            editForm() {
                if(this.documentLock) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Document Locked',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Data is being processed by ' + this.documentLock.user,
                    })
                }
                else {

                    this.isLoading = true
                    this.maxRetry = this.maxRetry - 1
                    this.warehouseOptions  = [];
                    this.stockTypeOptions = [] ;
                    this.$http.all([
                        this.$http.post('master/clients'), 
                        this.$http.post('master/ordertypes'), 
                        this.$http.post('master/customers'), 
                        this.$http.post('master/product/showbyclient',{ client_code: this.data.transport_order.client.client_code }),
                        
                        this.$http.post('master/transporters'), 
                        this.$http.post('master/currency'), 
                        this.$http.post('master/servicetypes'), 
                        this.$http.get('master/paymenttypes'), 

                        this.$http.post('master/warehouses'), 
                        this.$http.post('master/stocktypes'),
                        this.$http.post('master/areas'),
                    ])

                    .then(this.$http.spread((clients, ordertypes, customers, products, transporters, currency, servicetypes, paymenttypes, warehouses, stocktypes, areas) => {
                        this.clientOptions = clients.data.data
                        this.orderTypeOptions = ordertypes.data.data
                        this.customerOptions = customers.data.data
                        this.transporterOption = transporters.data.data
                        this.currencyOption = currency.data
                        this.serviceTypeOption = servicetypes.data.data
                        this.paymentTypeOption = paymenttypes.data
                        this.areaOptions = areas.data.data
                        this.productOptions = []


                        warehouses.data.data.map(item => {
                                this.warehouseOptions.push({
                                    value: item.id,
                                    text: item.name
                                })
                            })

                        stocktypes.data.data.map(item => {
                            this.stockTypeOptions.push({
                                value: item.id,
                                text: item.name
                            })
                        })
    
                        products.data.data.map(item => {
                            this.productOptions.push({
                                value: item.id,
                                text: item.product_code,
                            })
                        })
    
                        setTimeout(() => {
                            this.editMode = true
                            this.isLoading = false
                        }, 500)
                    }))
                    .catch((error) => {
                        if(this.maxRetry < 0){
                            console.log(error)
                            this.isLoading = false
                            this.$vs.dialog({
                                type: 'confirm',
                                color: 'danger',
                                title: 'Server Error',
                                text: 'Try again?',
                                accept: () => {
                                    this.editForm()
                                    this.maxRetry = 10
                                },
                                acceptText: 'Yes',
                                cancelText: 'No'
                            })
                            return;
                        }
                        this.editForm()
                    })
                }
            },
            clientChange() {
                if(this.data.transport_order_details.length > 0) {
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Confirmation',
                        text: 'Changing client will remove details, continue?',
                        accept: () => {
                            this.data.transport_order_details = []
                            this.productOptions = []
                        },
                        acceptText: 'Yes',
                        cancelText: 'No'
                    });
                }
            },
            assignLineId() {
                let lineId = 1
                this.data.transport_order_details.map((detail, index) => {
                    if(detail.data_status != 'delete') {
                        detail.line_id = lineId
                        lineId++
                    }
                })
            }
        },
        mounted(){
            this.fetchAllData()
            this.$http.get('attachment/'+this.$route.params.id).then((res) => {
            this.attachments = res.data.result
        });
        },
    }
</script>